
<script>
    import PreviewComponent from "./PreviewComponent";    
    import PaymentProductDetailsComponent from '../../components/pagesbuilder/dynamic-components/PaymentProductDetailsComponent.vue';
    

    export default {
        name: "PreviewPaymentProductDetailsComponent",
        mixins: [PreviewComponent, PaymentProductDetailsComponent],                        
        methods:{
            navigateToProductPage() {
                window.location.href = this.productUrl;
            }           
        }
    }
</script>
